(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-edit-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fall-edit-launch')) {
  customElements.define('fall-edit-launch', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state !== 'closed' || this.timer) return;
      const opens = Number(this.dataset.opens) * 1000;
      if (!Number.isFinite(opens) || opens <= 0) return;
      const refresh = () => {
        const url = new URL(window.location.href);
        const stamp = String(opens);
        if (url.searchParams.get('_fall_launch') === stamp) return;
        const key = 'fall-launch:' + url.pathname + ':' + stamp;
        try {
          if (window.sessionStorage.getItem(key)) return;
          window.sessionStorage.setItem(key, '1');
        } catch (_) {}
        url.searchParams.set('_fall_launch', stamp);
        window.location.replace(url.toString());
      };
      const check = () => {
        const remaining = opens - Date.now();
        if (remaining <= 0) refresh();
        else this.timer = window.setTimeout(check, Math.min(remaining + 1000, 2147483647));
      };
      check();
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fall-edit-launch')) {
  customElements.define('fall-edit-launch', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.state !== 'closed' || this.timer) return;
      const opens = Number(this.dataset.opens) * 1000;
      if (!Number.isFinite(opens) || opens <= 0) return;
      const refresh = () => {
        const url = new URL(window.location.href);
        const stamp = String(opens);
        if (url.searchParams.get('_fall_launch') === stamp) return;
        const key = 'fall-launch:' + url.pathname + ':' + stamp;
        try {
          if (window.sessionStorage.getItem(key)) return;
          window.sessionStorage.setItem(key, '1');
        } catch (_) {}
        url.searchParams.set('_fall_launch', stamp);
        window.location.replace(url.toString());
      };
      const check = () => {
        const remaining = opens - Date.now();
        if (remaining <= 0) refresh();
        else this.timer = window.setTimeout(check, Math.min(remaining + 1000, 2147483647));
      };
      check();
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  });
}

if (!customElements.get('fall-edit-builder')) {
  customElements.define('fall-edit-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = new Map();
      this.busy = false;
      this.uncertain = false;
      this.labels = JSON.parse(this.querySelector('[data-fe-labels]').textContent);
      this.list = this.querySelector('[data-fe-list]');
      this.message = this.querySelector('[data-fe-message]');
      this.addButton = this.querySelector('[data-fe-add-all]');
      this.cartLink = this.querySelector('[data-fe-cart-link]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.querySelectorAll('.fe-product form button[type="submit"]').forEach(button => {
        if (!button.disabled) button.textContent = this.labels.add_to_edit;
      });
      this.querySelector('[data-fe-summary]').hidden = false;
      this.addEventListener('submit', event => {
        const form = event.target.closest('.fe-product form');
        if (!form) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || this.uncertain) return;
        const option = form.querySelector('select').selectedOptions[0];
        if (!option || option.disabled) return;
        const id = option.value;
        const name = form.closest('.fe-product').querySelector('h3').textContent.trim();
        const item = this.items.get(id) || {id, name, format:option.dataset.format, price:Number(option.dataset.price), quantity:0};
        item.quantity = Math.min(item.quantity + 1, 99);
        this.items.set(id, item);
        this.render();
        this.message.textContent = name + ': ' + this.labels.added;
      }, true);
      this.list.addEventListener('click', event => {
        const button = event.target.closest('button[data-variant]');
        if (!button || this.busy || this.uncertain) return;
        const item = this.items.get(button.dataset.variant);
        if (!item) return;
        item.quantity = Math.min(99, item.quantity + Number(button.dataset.delta));
        if (item.quantity <= 0) this.items.delete(item.id);
        const focusId = item.id;
        const delta = button.dataset.delta;
        this.render();
        const replacement = Array.from(this.list.querySelectorAll('button')).find(b=>b.dataset.variant===focusId&&b.dataset.delta===delta);
        if (replacement) replacement.focus();
        else this.querySelector('[data-fe-summary-title]').focus();
      });
      this.addButton.addEventListener('click', () => this.addToBag());
      this.render();
    }
    render() {
      if (!this.busy && !this.uncertain) this.message.textContent = '';
      const count = Array.from(this.items.values()).reduce((sum,p)=>sum+p.quantity,0);
      const subtotal = Array.from(this.items.values()).reduce((sum,p)=>sum+p.price*p.quantity,0);
      // One offer replaces the other; never add the two percentages together.
      const rate = count >= 5 ? 0.20 : count > 0 ? 0.10 : 0;
      const savings = Math.round(subtotal * rate);
      this.list.replaceChildren();
      for (const item of this.items.values()) {
        const row = document.createElement('li');
        const copy = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = item.name;
        const format = document.createElement('small');
        format.textContent = item.format;
        copy.append(title,format);
        const controls = document.createElement('div');
        controls.className = 'fe-quantity';
        for (const delta of [-1,0,1]) {
          if (!delta) {
            const quantity = document.createElement('span');
            quantity.textContent = item.quantity;
            controls.append(quantity);
          } else {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.variant = item.id;
            button.dataset.delta = delta;
            button.textContent = delta<0 ? '−' : '+';
            button.setAttribute('aria-label', (delta<0?this.labels.remove_one:this.labels.add_one)+' '+item.name+' '+item.format);
            button.disabled = this.busy || this.uncertain || (delta>0 && item.quantity>=99);
            controls.append(button);
          }
        }
        const price = document.createElement('span');
        price.className='fe-line-price';
        price.textContent = this.money.format(item.price*item.quantity/100);
        row.append(copy,controls,price);
        this.list.append(row);
      }
      this.querySelector('[data-fe-empty]').hidden = count>0;
      this.querySelector('[data-fe-subtotal]').textContent = this.money.format(subtotal/100);
      this.querySelector('[data-fe-savings-row]').hidden = count === 0;
      this.querySelector('[data-fe-savings-label]').textContent = count >= 5 ? this.labels.bundle_savings : this.labels.automatic_savings;
      this.querySelector('[data-fe-savings]').textContent = '−' + this.money.format(savings/100);
      this.querySelector('[data-fe-total]').textContent = this.money.format((subtotal-savings)/100);
      const progress = this.querySelector('[data-fe-progress]');
      progress.max = 5;
      progress.value = Math.min(count,5);
      this.querySelector('[data-fe-count]').textContent = String(count);
      this.querySelector('[data-fe-guidance]').textContent = count>=5 ? this.labels.five_ready : count>0 ? this.labels.automatic_ready : this.labels.trio_guidance;
      this.addButton.disabled = count===0 || this.busy || this.uncertain;
      this.addButton.textContent = this.busy ? this.labels.adding : this.labels.add_edit;
    }
    async addToBag() {
      if (!this.items.size || this.busy || this.uncertain) return;
      if (this.dataset.preview === 'true') {
        this.message.textContent = this.labels.preview_only;
        return;
      }
      this.busy = true;
      this.message.textContent = '';
      this.render();
      const payload = {items:Array.from(this.items.values(),p=>({id:Number(p.id),quantity:p.quantity}))};
      try {
        const response = await fetch(this.dataset.addUrl + '.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description==='string'?result.description:this.labels.cart_error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.busy = false;
        this.uncertain = true;
        this.message.textContent = (error.message || this.labels.cart_error) + ' ' + this.labels.review_bag;
        this.cartLink.hidden = false;
        this.render();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
